const video = () => {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.video').forEach((video) => {
            const videoElement = video as HTMLElement;
            const videoPlay = videoElement.querySelector('[data-video-play]') as HTMLElement;
            const videoPlayer = videoElement.querySelector('[data-video-player]') as HTMLVideoElement;
            const videoOverlay = videoElement.querySelector('[data-video-overlay]') as HTMLElement;
            videoPlay.addEventListener('click', () => {
                console.log('click');
                videoPlayer.play();
                videoPlayer.style.visibility = 'visible';
                const videoPlayParent = videoPlay.parentElement as HTMLElement;
                if(videoPlayParent) {
                    videoPlayParent.style.display = 'none';
                }
                videoOverlay.style.display = 'none';
            });
        });
    });
};

export { video }